if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }
    }
  );
}

if (!customElements.get('quick-add-opener')) {
  class QuickAddOpener extends ModalOpener {
    constructor() {
      super();
      const url = new URL(this.button.dataset.productUrl.startsWith('/') ? window.location.origin + this.button.dataset.productUrl : this.button.dataset.productUrl);
      const params = url.searchParams;
      params.set('view', 'modal-quick-add');
      url.search = params.toString();

      this.url = url;
    }

    openModal(trigger) {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(trigger);
      else this.renderModal(trigger)
    }

    renderModal(trigger) {
      if (!this.url) return;
      trigger.setAttribute('aria-disabled', true);
      trigger.classList.add('loading');
      trigger.querySelector('.loading__spinner').classList.remove('hidden');
      fetch(this.url)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productQuickAdd = responseHTML.querySelector('.section--product-modal-quick-add');

          this.removeDOMElements();
          this.preventDuplicatedIDs();
          setTimeout(() => {
            this.setHTML(this.productQuickAdd);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.preventVariantURLSwitching();
          })

        })
        .finally(() => {
          setTimeout(() => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(trigger);
            trigger.removeAttribute('aria-disabled');
            trigger.classList.remove('loading');
            trigger.querySelector('.loading__spinner').classList.add('hidden');

            this.productInfo = this.querySelector('product-info');
            this.restockButton = this.querySelector('.restock-custom-button');
            this.restockJson = this.querySelector('.restock-json');
            if (this.restockJson) this.restockProductInfo = JSON.parse(this.restockJson.textContent);
            if (this.restockButton) this.restockButton.addEventListener('click', this.bindTriggerRestockModal);

            if (typeof window._RestockRocket == 'undefined' && this.restockButton) this.restockButton.classList.add('hidden');
          }, 300)
        });
    }

    setHTML(html) {
      this.modals = this.productQuickAdd.querySelectorAll('quick-add-modal, .quick-add-modal--modal')
      const scripts = Array.from(html.querySelectorAll('script'))
      this.modals.forEach(element => {
        document.body.appendChild(element);
      });


      scripts.filter(tag => !tag.classList.contains('klaviyo-skip-script')).forEach(scriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(scriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(scriptTag.innerHTML));
        document.body.appendChild(newScriptTag);
      })
    }

    removeDOMElements() {
      this.productQuickAdd.querySelector('quick-add-modal').classList.remove('quick-add-modal-section')
    }

    preventVariantURLSwitching() {
      const variantPicker = this.productQuickAdd.querySelector('variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    preventDuplicatedIDs() {
      const sectionId = this.productQuickAdd.querySelector('quick-add-modal').dataset.section;
      this.productQuickAdd.innerHTML = this.productQuickAdd.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productQuickAdd.querySelectorAll('variant-selects, product-info').forEach((element) => {
        if (sectionId != undefined)
          element.dataset.originalSection = sectionId;
      });
    }

  }

  customElements.define('quick-add-opener', QuickAddOpener);
}